export default {
  setInvoicesData(state, invoices) {
    state.invoices = invoices;
  }
}
